import { render, staticRenderFns } from "./PartnerListIframe.vue?vue&type=template&id=33c7c758&"
import script from "./PartnerListIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports